import { graphql } from '../gql';

/**
 * `vendors.name` is aliased to Internal Name: it's what the session stores as each vendor's
 * `name`, and Internal Name tells apart locations that share an External Name in restaurant
 * pickers (matches the Availability tab).
 */
export const createOmniauthSession = graphql(`
  mutation CreateOmniauthSession($nonce: String!) {
    createSession(input: { nonce: $nonce, omniauthRequest: true }) {
      session {
        token
        firstTimeUserClientLogin
        user {
          id
          email
          firstName
          lastName
          phoneNumber
          uuid
          vendors {
            id
            name: internalName
          }
          lastLogins {
            client {
              label
              token
            }
            time
          }
        }
      }
      error {
        message
      }
    }
  }
`);
